<template>
    <Toast />
    <div class="p-grid">
      <div class="p-col-12">
        <div class="p-text-center">
          <h1>All about football.</h1>
        </div>
      </div>
    </div>
    <div class="grid">
      <div class="p-col-12 p-md-6 p-fluid p-mx-auto">
        <div class="p-card p-p-5">
          <span class="p-float-label p-mb-5 p-inputtext-lg">
            <InputText id="email" type="text" v-model="email"
                    @keyup.enter="login()" />
            <label for="email">E-mail</label>
          </span>
          <span class="p-float-label p-mb-5 p-inputtext-lg">
            <Password id="password" v-model="password" :feedback="false"
                    @keyup.enter="login()" />
            <label for="password">Password</label>
          </span>
          <Button label="Login" @click="login()" class="p-text-bold" />
        </div>
      </div>
    </div>

    <!-- <router-link to="/hello">Click here to say HELLOOOOO</router-link> -->
</template>

<script>
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
import Button from 'primevue/button';
import Toast from 'primevue/toast';
import crypto from 'crypto';

import { isEmpty } from '../utils/utils'
import Const from '../utils/const'

export default {
    name: 'Login',
    data() {
        return {
        email: '',
        password: ''
        }
    },
    components: {
        InputText, Password, Button, Toast
    },
    emits: ['loginResult', 'pageLoaded'],
    created() {
        this.$emit('loginResult', false)
    },
    beforeMount() {
        this.$emit('pageLoaded', {
            title: "Login"
        })
    },
    methods: {
        async login() {
            let self = this;
            let cookies = this.$cookies,
                router = this.$router,
                toast = this.$toast
            let email = this.email,
                password = this.password;
                
            if(isEmpty(email) || isEmpty(password)) {
                toast.add({severity:'warn', summary: 'Login failed', detail: 'Login credentials can\'t be empty.', life: 3000});
                return
            }

            try {
                let passHash = crypto.createHash('sha256').update(password).digest('hex');

                let response = await this.$http.post('api/users/login', {
                    email: email,
                    password: passHash
                })

                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['auth-token'])) {
                    // toast.add({severity: 'success', summary: 'Welcome', detail: response.data.mesaj, life: 1500});
                    cookies.set("token", response.headers['auth-token']);
                    self.$emit('loginResult', true)
                    router.push('/dashboard')
                } else {
                    toast.add({severity:'warn', summary: 'Failed', detail: response.data.mesaj, life: 3000});
                }
            } catch(error) {
                console.log(error)
                toast.add({severity: 'error', summary: 'Error', detail: error});
            }
        }
    }
}

</script>
